// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-code {
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  margin-top: 8px;
  border: 1px solid #404040; }

.scannerPage .col-6 {
  max-width: 75%; }
`, "",{"version":3,"sources":["webpack://./src/components/Scanner/scanner.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE","sourcesContent":[".qr-code {\n  margin-right: auto;\n  margin-left: auto;\n  text-align: center;\n  margin-top: 8px;\n  border: 1px solid #404040; }\n\n.scannerPage .col-6 {\n  max-width: 75%; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
